import { Divider } from "@portal/BaseComponents/Divider/AntDivider";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import {
  CancelButton,
  SaveButton,
} from "@portal/BaseComponents/UI/ActionButtons";

interface FilterFooterProps {
  onSubmit: () => void;
  onCancel: () => void;
  disable?: boolean;
  loading?: boolean;
}
function FilterFooter(props: FilterFooterProps) {
  const { disable, onCancel, onSubmit } = props;
  return (
    <Flex
      style={{
        marginTop: "var(--space-16)",
        width: "100%",
      }}
      vertical
      space="12"
    >
      <Divider
        style={{
          margin: 0,
        }}
      />
      <Flex style={{ width: "100%" }} justify="flex-end">
        <CancelButton text="Cancel" onClick={onCancel} />
        <SaveButton text="Save" disabled={disable} onClick={onSubmit} />
      </Flex>
    </Flex>
  );
}

export { FilterFooter };
